
export function getCaretPosition(editableElement: HTMLElement | null):number {
	let caretPos = 0, sel, range;
	if (window.getSelection) {
		sel = window.getSelection();
		if (sel && sel.rangeCount) {
			range = sel.getRangeAt(0);
			if (range.commonAncestorContainer.parentNode === editableElement) {
				caretPos = range.endOffset;
			}
		}
	}
	return caretPos;
}

export function setCaretPosition(editableElement: HTMLElement | null, pos: number):void {
	let range = document.createRange();
	let sel = window.getSelection();

	if (editableElement) {
		const chn = editableElement.childNodes;
		if (chn.length > 0) {
			range.setStart(chn[0], pos);
			range.collapse(true);

			if (sel) {
				sel.removeAllRanges();
				sel.addRange(range);
			}
		}
	}
}

export function isBlank(editableElement: HTMLElement | null): boolean {
	const content = editableElement?.textContent ?? "";
	return content.trim().length === 0;
}

export function getTextLength(editableElement: HTMLElement | null): number {
	return editableElement?.textContent?.length ?? 0;
}

export function caretAtStart(editableElement: HTMLElement | null):boolean {
	if (editableElement == null) return false;
	return getCaretPosition(editableElement) === 0;
}
export function caretAtEnd(editableElement: HTMLElement | null):boolean {
	if (editableElement == null) return false;
	return getCaretPosition(editableElement) === getTextLength(editableElement);
}

export function hasSelection(): boolean {
	const sel = window.getSelection();
	return sel != null && sel.rangeCount > 0 && !sel.isCollapsed;
}